import script from "./HelpCenterLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpCenterLayout.vue?vue&type=script&setup=true&lang=ts"

import "./HelpCenterLayout.vue?vue&type=style&index=0&id=4ca5c77e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\kili-operation-page-lite\\kili_admin_view\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca5c77e"]])

export default __exports__